import React, { useState, useRef } from "react";
import "./OtpPage.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Flex, Spinner } from "@chakra-ui/react";
import axios from "axios";
import { baseUrl } from "../../../../../boot";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { SingUp_ForgotPasswordOtpVerify } from "../../../../redux/reduxApi/SingIn&SingUp/ForgotpasswordAPI";
import { verifyCustomerWithOtp } from "../../../../redux/api/customer/customerAuth";

const OtpPage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [otp, setOtp] = useState(["", "", "", ""]);
    const inputRefs = useRef([]);
    const { email } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleChange = (index, e) => {
        const value = e.target.value;
        if (!/^[0-9]?$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;

        setOtp(newOtp);

        if (value && index < 3) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        const combinedOtp = otp.join("");
        if (combinedOtp.length !== 4) {
            setIsLoading(false);
            return;
        }
        verifyCustomerWithOtp({ email, otp: combinedOtp }).then((res) => {
            if (res.data.success) {
                toast.success(res.data.message);
                setTimeout(() => {
                    navigate("/login");
                }, 1500);
            } else {
                console.log(res.data)
                toast.error(res?.data?.message)
            }
        }).catch((err) => {
            toast.error(err?.response?.data?.message || err?.message || "Failed to verify OTP");
        }).finally(() => {
            setIsLoading(false)
        })
        // try {
        //   const response = await dispatch(
        //     SingUp_ForgotPasswordOtpVerify({ email, otp: combinedOtp })
        //   );
        //   console.log("OTP verification response:", response);

        //   if (response.payload.success) {
        //     toast.success(response.payload.message);
        //     setIsLoading(false);
        //     setTimeout(() => {
        //       navigate("/login");
        //     }, 1500);
        //   } else {
        //     setIsLoading(false);
        //     toast.error(response.payload.message);
        //   }
        // } catch (error) {
        //   console.error("Error verifying OTP:", error.message);
        //   toast.error(error.message);
        //   setIsLoading(false);
        // }
    };

    return (
        <div className="d-flex justify-content-center align-items-center vh-100 bg-light overflow-hidden">
            {/* {isLoading && (
                <div className="spinner-overlay">
                    <Spinner size="xl" color="pink.500" />
                </div>
            )} */}
            <div className="bg-white p-5 rounded-3 shadow-sm border text-center w-38 flex justify-center flex-col items-center">
                <ShieldCheck className="verification" size={50} />
                <p className="text-success" style={{ fontSize: "5.5rem" }}>
                    <i className="fa-solid fa-envelope-circle-check"></i>
                </p>
                <p className="h5">Please Check Your Email</p>
                <p className="text-muted">We've sent a code to {email}</p>
                <form onSubmit={handleSubmit}>
                    <div className="d-flex justify-content-center gap-2 my-4">
                        {otp.map((digit, index) => (
                            <input
                                key={index}
                                ref={(el) => (inputRefs.current[index] = el)}
                                className="otp-letter-input text-center fs-4 border border-secondary rounded"
                                type="text"
                                maxLength={1}
                                value={digit}
                                onChange={(e) => handleChange(index, e)}
                                onKeyDown={(e) => handleKeyDown(index, e)}
                            />
                        ))}
                    </div>
                    <div className="d-flex justify-content-center mt-4 gap-3">
                        <button
                            type="submit"
                            className="btn text-white !bg-orange-500 px-4 py-2 border-0 rounded"
                        >
                            {isLoading ? <> <Flex justifyContent={'center'} alignItems={'center'} gap={'2'} ><Spinner size={'sm'} /> <span>Loading..</span></Flex> </> : "Verify"}

                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary px-4 py-2 border-0 rounded"
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default OtpPage;
